import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import LotInfoFormLayout from './LotInfoFormLayout';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from "devextreme-react/toolbar";
import axios from "axios";
const PrimaryTabCommentFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "comment",
                "tableName": "",
                "label": "Comment:",
                "type": "textarea",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }    
        ]
    }
];

function PrimaryTabComment(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [forceRender, setForceRender] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const initialFormFields = {
        rowid: props.sourceId,
        comment: '',
    }
    const [formFields, setformFields] = useState(initialFormFields);
    const handleReset = () => {
        var rowid = props.sourceId;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetById(rowid);
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
    }, []);
    const handlePrimaryFormLoad = useCallback(() => {
    }, []);
    const handleFormSubmit = async (e) => {
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            
            var res = await axios.post
                (
                    `${window._env_.REACT_APP_APIS}/im/Transactionlocation/UpdateTransactionlocationInfo`,
                    formFields,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                );
        } catch (error) {
            console.error('Error submitting form:', error);
            //setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    const GetById = (id) => {
        try {
            setLoadPanelVisible(true);
            const response =  axios.get(`${window._env_.REACT_APP_APIS}/im/Transactionlocation/GetTransactionlocationById?id=${id}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res)=>{
                const responseData = res.data;
                setformFields(prevFields => ({
                    ...prevFields,
                    comment: responseData.comment,
                    ROWID: id,
                }));
                console.log("responseData:", JSON.stringify(responseData, null, 2));
            });
     
        } catch (error) {
            console.error('Error failed to get transaction data:', error);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };
    useEffect(() => {
        var rowid = props.sourceId;
        if (rowid != null && rowid != undefined && rowid != '') {
            GetById(rowid);
        }
    }, [props.sourceId]);
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                         
                            <Toolbar className="header">
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        onClick={handleFormSubmit}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                            <div className="AccordionItemBody">
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='b0866bc0-0acb-4b14-a624-ae3620f86f13'
                                    layoutName='WMTransactionDataEntryPrimayForm'
                                    defaultFormSchema={PrimaryTabCommentFormLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handlePrimaryFormLoad}
                                />
                            </div>
                         
                    </div>
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTabComment);